// extracted by mini-css-extract-plugin
module.exports = {"main":"PageWrapper_main__2G5Qu"};